// extracted by mini-css-extract-plugin
module.exports = {"uc":"UnderConstruction_uc__2dUMj","muc":"UnderConstruction_muc__17Xs5"};